import { useState, useEffect } from 'react';

export function useRoundCache<T>(key: string, initialValue: T) {
  const [state, setState] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn('Error reading localStorage', error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn('Error setting localStorage', error);
    }
  }, [key, state]);

  const clearCache = () => {
    try {
      window.localStorage.removeItem(key);
      setState(initialValue);
    } catch (error) {
      console.warn('Error removing localStorage', error);
    }
  };

  return [state, setState, clearCache] as const;
}
